import { FC, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { AiOutlineClose } from 'react-icons/ai';
import { RootState } from '../../../../store/rootReducer';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../components/Loader';

interface IProps {
  visible: boolean;

  onCancel(): void;
}

const StudentPaymentProcessModal: FC<IProps> = ({ visible, onCancel }) => {
  const { t } = useTranslation();
  const { paymentStep } = useSelector((root: RootState) => root.studentStudent);

  const [isPaymentFail, setIsPaymentFail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    // const timer = setTimeout(() => {
    //   if (paymentStep === 'complete') return;
    //   setIsPaymentFail(true);
    //   setIsLoading(false);
    // }, 1000 * 60);
    //
    // return () => clearTimeout(timer);
  }, []);

  const onLocalCancel = () => {
    isPaymentFail && onCancel();
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        title={t('student.student.button18')}
        visible={visible}
        onCancel={onLocalCancel}
        width={600}
        closeIcon={<AiOutlineClose onClick={onLocalCancel} />}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <Button key="cancel" className='btn-basic gray' onClick={onLocalCancel} disabled={!isPaymentFail}>
              {t('common.button.cancel')}
            </Button>
          </div>
        ]}
      >
        <div className="text-center">
          {isPaymentFail ? (
            <>
              <p>{t('student.student.text15')}</p>
              <p>{t('student.student.text16')}</p>
              <p>{t('student.student.text17')}</p>
            </>
          ) : (
            <>
              <p>{t('student.student.text18')}</p>
              <p>{t('student.student.text19')}</p>
              <p>{t('student.student.text20')}</p>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default StudentPaymentProcessModal;
